import type { MailboxInfo } from 'owa-client-types';
import type {
    MoveFolderPositionMutation,
    MoveFolderPositionMutationVariables,
} from './graphql/__generated__/MoveFolderPositionMutation.interface';
import type { ResolverContext } from 'owa-graph-schema';
import type { MutationFunction } from '@apollo/client';
import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MoveFolderPosition" */ './lazyIndex'),
    { name: 'MoveFolderPosition' }
);

export const lazyMoveFolderPosition: LazyAction<
    (
        moveFolderPositionMutation: MutationFunction<
            MoveFolderPositionMutation,
            MoveFolderPositionMutationVariables,
            ResolverContext
        >,
        moveFolderMutationVariables: MoveFolderPositionMutationVariables
    ) => Promise<void>,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.onMoveFolderPosition);
export const lazyMoveFolderPositionUpDown: LazyAction<
    (
        moveFolderPositionMutation: MutationFunction<
            MoveFolderPositionMutation,
            MoveFolderPositionMutationVariables,
            ResolverContext
        >,
        moveUp: boolean,
        folderIdOrigin: string,
        mailboxInfo: MailboxInfo
    ) => void,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.onMoveFolderPositionUpDown);
